import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../api/api";

export default function Sidebar() {
    const [insights, setInsights] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        setLoading(true);

        API.get("/api/articles/trending")
            .then((res) => {
                if (!isMounted) return;
                const data = Array.isArray(res.data) ? res.data : [];
                setInsights(data.slice(0, 4)); // keep it curated
            })
            .catch((err) => {
                console.error("Error fetching editor insights:", err);
                setInsights([]);
            })
            .finally(() => {
                if (isMounted) setLoading(false);
            });

        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <aside className="hidden lg:block sidebar">
            <div className="sticky top-24">
                <section className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">

                    {/* HEADER */}
                    <div className="px-5 py-4 border-b bg-gradient-to-r from-indigo-600 to-indigo-500 text-white">
                        <h3 className="text-lg font-semibold flex items-center gap-2">
                            🧠 Editor Insights
                        </h3>
                    </div>

                    {/* CONTENT */}
                    <div className="p-4 space-y-4">
                        {loading ? (
                            <p className="text-gray-400 text-sm text-center">
                                Loading insights…
                            </p>
                        ) : insights.length === 0 ? (
                            <p className="text-gray-500 text-sm text-center">
                                No insights available
                            </p>
                        ) : (
                            insights.map((article) => (
                                <Link
                                    to={`/article/${article.slug}`}
                                    key={article.id}
                                    className="
                                        block
                                        border-l-4 border-indigo-500
                                        pl-4 py-2
                                        rounded-md
                                        hover:bg-indigo-50
                                        transition
                                        group
                                    "
                                >
                                    {/* META */}
                                    <div className="flex items-center gap-2 mb-1">
                                        <span className="text-[11px] font-medium text-indigo-600 bg-indigo-100 px-2 py-0.5 rounded">
                                            {article.category || "Explained"}
                                        </span>
                                        <span className="text-[11px] text-gray-400">
                                            {article.read_time || "3 min read"}
                                        </span>
                                    </div>

                                    {/* TITLE */}
                                    <p
                                        className="
                                            text-sm font-semibold leading-snug
                                            text-gray-900
                                            group-hover:text-indigo-700
                                            transition
                                            line-clamp-2
                                        "
                                    >
                                        {article.title}
                                    </p>

                                    {/* INSIGHT LINE */}
                                    <p className="text-xs text-gray-600 mt-1 line-clamp-2">
                                        {article.excerpt ||
                                            "Why this topic matters more than it seems."}
                                    </p>
                                </Link>
                            ))
                        )}
                    </div>

                </section>
            </div>
        </aside>
    );
}
